export function getDescendentId(dropdownId, index) {
    return `${dropdownId}-${index}`;
}

//# sourceMappingURL=utils.js.map